import React, { useEffect, useState } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import InfiniteCalendar, {
    Calendar,
    withRange,
} from 'react-infinite-calendar';

import 'react-infinite-calendar/styles.css';

import { ConsultPeriodos, ConsultDiasInsc, diasDisabled, AddDiasIsc } from "../../funciones/PreferenciasAdminFunction";
import DiasInscTable from  './DiasInscTable';

const DiasInscripcion = (props) => {
    const [diasDisableds, setDiasDisableds] = useState([]);
    const [boton1, setBoton1] = useState({ icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true });
    const [periodosLoad, setPeriodosLoad] = useState(true);
    const [periodosSelect, setPeriodossSelect] = useState({ value: '', label: ' - Selecciona un Periodo - ' });
    const [Periodos, setPeriodos] = useState([]);
    const [preloader, setPreloader] = useState("Selecciona primero un periodo");
    const [diasInsc, setDiasInsc] = useState([]);

    useEffect(() => {
        diasDisabled ((resp) => {
            let contenido = [];
            let pre = "";
            if (resp.length === 0 ) pre = <div>No existen Días de Inscripción registrados</div>
            for (let i in resp){
                let date = resp[i].dia.split("/")
                let addDate = new Date(parseInt(date[2]), (parseInt(date[1]) - 1), parseInt(date[0]))
                contenido.push(addDate)
            }

            setDiasDisableds(contenido)
            setBoton1({ icon: "fa fa-plus", text: "Agregar",  disabled: false })
        })

        ConsultPeriodos ((resp) => {
            setPeriodos(resp[1]);
            setPeriodosLoad(false)
        })
    }, [props]);

    let diaSelect = (rango) => {
        let dateIn = new Date(rango.start);
        let dayIn = dateIn.getDate();
        let monthIn = dateIn.getMonth() + 1;
        let yearIn = dateIn.getFullYear();

        if (dayIn < 10) dayIn = `0${dayIn}`
        if (monthIn < 10) monthIn = `0${monthIn}`

        let diaInF = `${dayIn}/${monthIn}/${yearIn}`;

        let dateOut = new Date(rango.end);
        let dayOut = dateOut.getDate();
        let monthOut = dateOut.getMonth() + 1;
        let yearOut = dateOut.getFullYear();

        if (dayOut < 10) dayOut = `0${dayOut}`
        if (monthOut < 10) monthOut = `0${monthOut}`
        
        let diaOutF = `${dayOut}/${monthOut}/${yearOut}`;

        document.getElementById("fechaInAdmI").value = diaInF;
        document.getElementById("fechaOutAdmI").value = diaOutF;
    }

    let cambiaPeriodo = (periodosSelect) => {
        setPeriodossSelect(periodosSelect)
        setPreloader(<React.Fragment><i className = "fa fa-spinner fa-spin"></i> Buscando, espera</React.Fragment>)

        ConsultDiasInsc(periodosSelect.value, (resp) => {
            if (resp.length === 0 ) setPreloader("No existen Dias de Inscripción para el periodo seleccionado")
            setDiasInsc(resp);
        })
    }

    let agregar = () => {
        if (boton1.disabled === true) return null;
        let diaIn = document.getElementById("fechaInAdmI").value;
        let diaOut = document.getElementById("fechaOutAdmI").value;

        if (diaIn === "" || diaOut === ""){
            setBoton1({ icon: "fa fa-plus", text: "Agregar",  disabled: false })
            toast.error("Debes indicar el rango de fechas primero",{autoClose: 4000});
            return null
        }

        if (periodosSelect.value === ""){
            setBoton1({ icon: "fa fa-plus", text: "Agregar",  disabled: false })
            toast.error("Debes indicar el rango de fechas primero",{autoClose: 4000});
            return null
        }

        setBoton1({ icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true });
        AddDiasIsc (diaIn, diaOut, periodosSelect.value, () => {
            document.getElementById("fechaInAdmI").value = "";
            document.getElementById("fechaOutAdmI").value = "";
            setPeriodossSelect({ value: '', label: ' - Selecciona un Periodo - ' })
            setBoton1({ icon: "fa fa-plus", text: "Agregar",  disabled: false })

            ConsultDiasInsc(periodosSelect.value, (resp) => {
                if (resp.length === 0 ) setPreloader("No existen Dias de Inscripción para el periodo seleccionado")
                setDiasInsc(resp);
            })

            toast.info("Se han agregado los Dias no Laborables",{autoClose: 4000});
        })
    }

    let calendario = () => (
        <InfiniteCalendar
            Component={withRange(Calendar)}
            width="100%"
            height={250}
            disabledDays={props.DiasOff}
            locale={{
                locale: require('date-fns/locale/es'),
                headerFormat: 'D MMM',
                weekdays: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
                todayLabel: {
                    long: 'Hoy',
                    short: 'Hoy'
                }
            }}
            theme={{
                selectionColor: 'rgb(160, 85, 92)',
                textColor: {
                    default: '#333',
                    active: '#FFF'
                },
                weekdayColor: 'rgb(160, 85, 92)',
                todayColor: 'rgb(160, 85, 92)',
                headerColor: 'rgb(210, 137, 125)',
                floatingNav: {
                    background: 'rgba(160, 85, 92, 0.96)',
                    color: '#FFF',
                    chevron: 'rgba(255, 255, 255, 0)'
                }
            }}
            onSelect={(date) => { diaSelect(date) }}

            selected={{
                start: new Date(),
                end: new Date()
            }}

            disabledDates={diasDisableds}
        />
    )

    let diasInscripcionAsig = () => {
        if (diasInsc.length === 0 ) return (
            <tr>
                <td colSpan={3} align="center">{preloader}</td>
            </tr>
        )

        return (
            diasInsc.map(option => (
                <DiasInscTable key = {option.id} datos = {option} 
                delResp = {() => {
                    ConsultDiasInsc(periodosSelect.value, (resp) => {
                        if (resp.length === 0 ) setPreloader("No existen Dias de Inscripción para el periodo seleccionado")
                        setDiasInsc(resp);
                    })
                }}/>
            ))
        )
    }

    let addDias = () => {
        const styles = {
            padding: 2, fontSize: 12
        }

        return(
            <React.Fragment>
                <div className="custom-alert-danger">Agregar dia(s) de inscripción</div>
                <Row className="custom-mt-10">
                    <Col md={6}>
                        <input className="form-control" placeholder="DD/MM/AAA" disabled id="fechaInAdmI" title="Para añadir la fecha haz click en un rango del calendario"/>
                        <div className="text-muted" style={{fontSize:12}}>Desde</div>
                    </Col>
                    <Col md={6}>
                        <input className="form-control" placeholder="DD/MM/AAA" disabled id="fechaOutAdmI" title="Para añadir la fecha haz click en un rango del calendario"/>
                        <div className="text-muted" style={{fontSize:12}}>Hasta</div>
                    </Col>
                    <Col md={8} className="custom-mt-10">
                        <Select
                            isSearchable ={true}
                            isLoading = {periodosLoad}
                            value={periodosSelect}
                            onChange={cambiaPeriodo}
                            options={Periodos}
                        />
                    </Col>
                    <Col md={4} className="custom-mt-10" align="right">
                        <button className="btn btn-danger" style={{borderWidth: 1}} onClick = {() => {agregar()}}><i className={boton1.icon}></i> {boton1.text}</button>
                    </Col>
                </Row>
                <div className="custom-alert-danger custom-mt-10">Dias de inscripción registrados</div>
                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "37vh", overflowX:"hidden"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr style = {{backgroundColor: "a0555c", color: "fff"}}>
                                <td align="center" width="30%" style={styles}><strong>Dia</strong></td>
                                <td align="center" colSpan={2} width="70%" style={styles}><strong>Periodo</strong></td>
                            </tr>
                            {diasInscripcionAsig()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    return (
        <Row className="custom-mt-10">
            <Col md={5}>
                <div className="custom-alert-danger" style={{padding: 5}}>
                    {calendario()}
                    <div align="center" className="custom-mt-10" style={{fontSize: 10}}>Si deseas seleccionar <strong>un solo día</strong> haz doble click sobre el</div>
                </div>
            </Col>
            <Col md={7}>
                {addDias()}
            </Col>
        </Row>
    )
}

export default DiasInscripcion;


// WEBPACK FOOTER //
// ./src/views/Opciones/DiasInscripcion.jsx